import { ICommandData } from '@tencent/slide-sdk-model';
import { PasswordError } from '@src/slide/domain/slide-app/scenes/local-edit/core/interfaces/local-edit-data-converter.interface';
import { DocxInfo } from '@tencent/mega-sdk-protocols';
import { ModalReturnType } from '@tencent/docs-crypto-kit';

export interface IDocVerifierManager {
    /**
     * 获取当地是否处于用户只读查看状态
     */
    getIsReadOnly(): boolean;

    /**
     * 获取用户输入的打开密码，用于保存文档时传给转换工具，否则打开密码会丢失
     */
    getOpenPassword(): string | undefined;

    /**
     * 显示编辑密码弹框
     */
    showModifyVerifier(): Promise<ModalReturnType>;

    /**
     * 校验打开密码弹框
     * @param headData
     * @param publishDocxInfo
     */
    checkModifyVerifier(
        headData: ICommandData,
        publishDocxInfo: (info: DocxInfo) => void,
    ): Promise<void>;

    /**
     * 校验打开密码弹框
     * @param err
     * @param code
     * @param continueWithPassword
     * @param publishDocxInfo
     */
    checkOpenVerifier(
        err: PasswordError,
        code: number,
        continueWithPassword: (password: string) => void,
        publishDocxInfo: (info: DocxInfo) => void,
    ): void;
}
// 对接文档可参考
// https://doc.weixin.qq.com/doc/w3_AZ4AIQZKAOw4Sbgw9pDTjaNMP24tI?scode=AJEAIQdfAAojEdn7uZAZ4AIQZKAOw
export interface IPasswordParam {
    cryptAlgorithmSid: string;
    spinCount: string;
    saltData: string;
    hashData: string;
}

export enum IReportFileType {
    local = 'local',
    drive = 'drive',
    tdoc = 'tdoc',
}

export enum IReportPasswordType {
    open = 'open',
    edit = 'edit',
}

export enum IReportOperateRes {
    success = 'success',
    fail = 'fail',
}
